import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-fellowship-details',
  templateUrl: './fellowship-details.component.html',
  styleUrls: ['./fellowship-details.component.css']
})
export class FellowshipDetailsComponent implements OnInit {
  communityID
  communityData
  url
  loading = false
  constructor(private authService: AuthservicesService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.communityID = params["id"];
    });

    this.communityDetail();

  }


  communityDetail() {
    this.authService.communitydetails(this.communityID).subscribe((res: any) => {
      this.loading = true;
      this.communityData = res.data
    },
      error => {
        console.log(error)
      })
  }






}
